// Vite entry point: styles plus the JSInterop utility module, which self-registers on window.
// Inactivity tracking lives in CDPHE.HealthInformatics.UI (window.SessionManager).
import './styles/main.scss';

import './utils/browser';

console.log('✅ NaturalMedicine.App - Vite loaded successfully');
console.log('📦 Available JSInterop utilities:', {
  browser: 'browserUtils'
});

// Vite build mode, separate from Blazor's IWebAssemblyHostEnvironment.Environment.
console.log('🌍 Vite build mode:', import.meta.env.MODE);
